export enum ServiceDefColumn {
  SOLUTION = 'solution'
}

export const serviceDefColumns = Object.values(ServiceDefColumn) as string[];
